export const NOTE_NODE_ID_PREFIX = "note-";
export const noteNodeId = (noteId)=>`${NOTE_NODE_ID_PREFIX}${noteId}`;
export const isNoteNodeId = (nodeId)=>nodeId.startsWith(NOTE_NODE_ID_PREFIX);
/** Inverse of `noteNodeId`: strip the prefix back to the note's `_id`. */ export const noteIdFromNodeId = (nodeId)=>nodeId.slice(NOTE_NODE_ID_PREFIX.length);
/**
 * Build React Flow sticky-note nodes from notes. These are appended AFTER
 * layout — they carry their own absolute geometry and must never be fed to ELK
 * (ADR 0008). `flowNote` nodes have no swimlane parent.
 */ export function buildNoteNodes(notes, mode, callbacks = {}) {
    return notes.map((note)=>({
            id: noteNodeId(note._id),
            type: "flowNote",
            position: {
                x: note.geometry.x,
                y: note.geometry.y
            },
            width: note.geometry.width,
            height: note.geometry.height,
            // Pre-fill `measured`: react-flow's `adoptUserNodes` wipes a re-adopted
            // node's `internals.handleBounds` when the node carries no `measured`
            // (notes are rebuilt from props, so they never accumulate one), and the
            // marquee hit-test (`getNodesInside`) force-selects any node without
            // handle bounds — box-selecting anywhere would wrongly select every note
            // until the next measure pass. The explicit geometry IS the DOM size, so
            // this is the truth, not a guess.
            measured: {
                width: note.geometry.width,
                height: note.geometry.height
            },
            draggable: mode === "edit",
            selectable: mode === "edit",
            // Float above the graph + swimlane containers (swimlanes sit at z -1).
            zIndex: 5,
            data: {
                canvasKind: "note",
                noteId: note._id,
                text: note.text,
                category: note.category,
                targets: note.targets,
                mode,
                onTextChange: callbacks.onTextChange,
                onResizeEnd: callbacks.onResizeEnd,
                onDelete: callbacks.onDelete,
                onCategoryChange: callbacks.onCategoryChange,
                onToggleLink: callbacks.onToggleLink
            }
        }));
}
/**
 * Build connector edges from each note to the nodes it targets. A target whose
 * node is absent from the current graph is skipped (orphan fallback — the note
 * renders free; ADR 0008 decision #7).
 */ export function buildNoteConnectorEdges(notes, presentNodeIds) {
    const edges = [];
    for (const note of notes){
        for (const targetId of note.targets){
            if (!presentNodeIds.has(targetId)) continue;
            edges.push({
                id: `noteedge-${note._id}-${targetId}`,
                source: noteNodeId(note._id),
                target: targetId,
                type: "noteConnector",
                selectable: false,
                focusable: false,
                deletable: false,
                zIndex: 4
            });
        }
    }
    return edges;
}

//# sourceMappingURL=notes.js.map